var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list",class:`styled-${_vm.list.length}`,style:(_vm.style)},_vm._l((_vm.list),function(item,i){return _c('card-item',{key:i,style:(item.style),attrs:{"title":item.title,"description":item.description,"icon":item.icon,"content-width":item.contentWidth,"layout":item.layout || _vm.getLayout(i)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }